import {
  DigitalDocument,
  DigitalDocumentStatus,
  TaxAuthorityValidations,
} from 'modules/Documents/models/document';
import { VerifactuInvoice } from 'modules/Documents/models/verifactuInvoice';
import {
  VerifactuTaxAuthority,
  VerifactuTaxAuthorityStatus,
} from 'modules/Documents/models/verifactuTaxAuthority';

export const normalizeVerifactuTaxAuthorityToDocument = (
  verifactu: VerifactuInvoice
): DigitalDocument | undefined => {
  if (!verifactu?.taxAuthority?.status) {
    return undefined;
  }

  const { taxAuthority } = verifactu;

  return {
    id: taxAuthority.identifier,
    status: normalizeVerifactuTaxAuthorityStatusToDigitalDocumentStatus(
      taxAuthority.status
    ),
    taxAuthorityValidations:
      normalizeVerifactuTaxAuthorityValidations(taxAuthority),
    errors: [],
    updatedAt: taxAuthority.registeredAt,
  };
};

const TAX_AUTHORITY_STATUS_MAP: Record<
  VerifactuTaxAuthorityStatus,
  DigitalDocumentStatus
> = {
  [VerifactuTaxAuthorityStatus.Registered]: DigitalDocumentStatus.PRESENTED,
  [VerifactuTaxAuthorityStatus.RegisteredWithErrors]:
    DigitalDocumentStatus.PRESENTED_WITH_ERRORS,
  [VerifactuTaxAuthorityStatus.Rejected]: DigitalDocumentStatus.REJECTED,
  [VerifactuTaxAuthorityStatus.NotRegistered]:
    DigitalDocumentStatus.FAIL_TO_CONTACT,
  [VerifactuTaxAuthorityStatus.Error]: DigitalDocumentStatus.IN_PROGRESS,
};

const normalizeVerifactuTaxAuthorityStatusToDigitalDocumentStatus = (
  status: VerifactuTaxAuthorityStatus
): DigitalDocumentStatus => {
  return TAX_AUTHORITY_STATUS_MAP[status] ?? DigitalDocumentStatus.IN_PROGRESS;
};

const normalizeVerifactuTaxAuthorityValidations = (
  taxAuthority: VerifactuTaxAuthority
): TaxAuthorityValidations[] => {
  return taxAuthority.errors.map(({ code, message }) => {
    return {
      code,
      description: {
        ES: message,
        EU: message,
      },
    };
  });
};
